/*
 * @Author: rxw
 * @Date: 2025-12-08 22:43:59
 * @LastEditors: rxw
 * @LastEditTime: 2025-12-15 11:43:19
 * @Description: file contents
 */
import { getCookie, setCookie, logoutAndRedirect, getOriginCookie } from '@/utils/utils';
import { localCache, sessionCache } from '@/utils/storageHandler';
import { getToperDomain } from '@/utils/multipleDomain';
import appJSON from '../app.json';
import { app } from '@monorepo/utils';
import registryMicroAPI from './utils/registry-micro-api';
import Client, { IClientConfig } from 'mars-front-api-sdk/types/Client';
import { makeClient } from 'mars-front-api-sdk';

// @monorepo/utils 现在通过全局单例机制自动共享，不再需要手动暴露
window.setCookie = setCookie;
window.getOriginCookie = getOriginCookie;
window.getToperDomain = getToperDomain;
window.getCookie = getCookie;
window.localCache = localCache;
window.sessionCache = sessionCache;
window.logoutAndRedirect = logoutAndRedirect;
window.version = appJSON.dist;
window.makeClient = makeClient;

// 暴露菜单注册API供子应用使用
window.registerMicroAPI = (props: {
  appRoutes: any[];
  makeClient: (config: IClientConfig) => Client;
  menusFunction: () => Partial<Record<string, any>>;
  commonFunctionMenus: Record<string, string>;
  buildTime: string;
  appName: string;
}) => {
  registryMicroAPI.registerMicro(props);
};
// 确保 app 实例在 base-app 中初始化并挂载到 window
// 这样微应用就可以使用同一个共享的 app 实例
if (typeof window !== 'undefined' && !(window as any).__MONOREPO_APP__) {
  (window as any).__MONOREPO_APP__ = app;
}

window.MARS_BASE_CONFIG = {
  REACT_APP_ENV: process.env.REACT_APP_ENV as 'dev' | 'proxy' | 'prod' | 'qa_dev',
  MARS_BASE_URL: process.env.REACT_APP_ENV === 'qa_dev' ? STOCK_BASE_URL_QA : STOCK_BASE_URL,
  MERCHANT_CLIENT_ID: 'mars_web_merchant_app',
  MERCHANT_CLIENT_SECRET: 'ek9992ge6gwM42Z9yrliVIxHCF18chGW',
  CLIENT_ID: 'mars_web_app',
  CLIENT_SECRET:
    process.env.REACT_APP_ENV === 'prod'
      ? 'dd6eC17B6L7qExbPHg9fCBrnSvQpz7Q7'
      : 'Bd6eC17B6L7qExbPHg9fCBrnSvQpz7Q7',
  // 登录页域名
  LOGIN_PAGE_HOST_NAME: LOGIN_PAGE_HOST_NAME,
  // 微信登录appid
  WX_LOGIN_APPID: WX_LOGIN_APPID,
  // 微信登录secret
  WX_LOGIN_SECRET: WX_LOGIN_SECRET,
  // OpenTelemetry trace exporter
  OTLP_TRACE_EXPORTER_URL: OTLP_TRACE_EXPORTER_URL,
  // ARMS RUM
  ARMS_RUM_ENDPOINT: ARMS_RUM_ENDPOINT,
  ARMS_RUM_ENV: ARMS_RUM_ENV,
  ...(window.MARS_CONFIG || {}),
};
